import theme from '../../../theme';
import { localAuction } from '../../../utils/constants/auction';
import { sidebarWidthInPx } from '../../../utils/constants/sidebar';
import { USER_ROLES } from '../../../utils/constants/users/userRoles';

/**
 * Styles for the sidebar container
 * @type {Object}
 */

export const sidebarContainer = ({ auth }) => {
  console.log(auth, `sidebarContainer`);

  return {
    boxSizing: 'border-box',
    width: `${sidebarWidthInPx}px`,
    padding: '1rem',
    borderRadius: '0',
    height: '100vh',
    position: 'sticky',
    top: 0,
    background:
      auth?.user_role === USER_ROLES.admin
        ? auth?.auction_type === localAuction
          ? theme.palette.primary.main
          : `linear-gradient(to bottom, ${theme.palette.primary.gradient1}, ${theme.palette.primary?.gradient2})`
        : auth?.user_role === USER_ROLES.buyer
        ? `linear-gradient(to bottom, ${theme.palette.primary.gradient1}, ${theme.palette.primary?.gradient2})`
        : theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    color: theme.palette.text.secondary,
    fontFamily: theme.typography.fontFamily,
  };
};
// export const sidebarContainer = {
//   boxSizing: "border-box",
//   width: "250px",
//   padding: "1rem",
//   borderRadius: "0",
//   height: "100vh",
//   position: "sticky",
//   top: 0,
//   backgroundColor: theme.palette.primary.main,
//   display: "flex",
//   flexDirection: "column",
//   color: theme.palette.text.secondary,
//   fontFamily: theme.typography.fontFamily
// };

/**
 * Styles for the navigation list container
 * @type {Object}
 */
export const navListContainer = {
  marginTop: '1.5rem',
  maxHeight: '80vh',
  overflowY: 'scroll',
  '::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '::-webkit-scrollbar': {
    width: '3px' /* This is necessary to show the thumb */,
  },
  '::-webkit-scrollbar-thumb': {
    backgroundColor: '#c2bcbcff' /* This is the thumb's color */,
    borderRadius: '4px' /* Optional: adds rounded corners to the thumb */,
  },
};

/**
 * Styles for navigation list items
 * @type {Object}
 */
export const navListItem = (isSelected) => {
  return {
    borderRadius: '4px',
    marginBottom: '4px',
    cursor: 'pointer',
    background: `${isSelected ? theme.palette.text.secondary : 'transparent'} !important`,
    color: isSelected ? theme.palette.primary.main : theme.palette.text.secondary,
    fontFamily: theme.typography.fontFamily,
    '&:hover': {
      background: `${isSelected ? theme.palette.text.secondary : 'transparent'} !important`,
    },
  };
};
// export const navListItem = {
//   borderRadius: "4px",
//   marginBottom: "4px",
//   cursor: "pointer",
//   fontFamily: theme.typography.fontFamily,
//   "&:hover": {
//     backgroundColor: theme.palette.action.hover,
//   },
// };

/**
 * Styles for footer/signout section
 * @type {Object}
 */
export const sidebarFooter = {
  paddingTop: '1rem',
  borderTop: `1px solid ${theme.palette.divider}`,
  marginTop: 'auto',
};

/**
 * Styles for signout button
 * @type {Object}
 */
export const sidebarButton = {
  width: '100%',
  border: `1px solid ${theme.palette.common.white}`,
  borderRadius: '4px',
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
};

/**
 * Styles for sidebar button icon
 * @type {Object}
 */
export const sidebarButtonIcon = {
  minWidth: '0 !important',
  color: theme.palette.common.white,
};

/**
 * Styles for sidebar button text
 * @type {Object}
 */
export const sidebarButtonText = {
  marginLeft: '0.5rem',
  minWidth: '0 !important',
  color: theme.palette.common.white,
  fontFamily: theme.typography.fontFamily,
};
